const SOFTGARDEN_APPRENTICE_OPTION = ['Student/in', 'Auszubildende'];

export default function(job) {
  let isApprenticeship = false;
  job?.audiences.forEach(audience => {
    isApprenticeship = (SOFTGARDEN_APPRENTICE_OPTION.filter(option => audience.includes(option)).length > 0);
    if (isApprenticeship) {
      return isApprenticeship;
    }
  });
  return isApprenticeship;
}
